import React, { useContext } from "react";
import config, { getParameterByName, merchantCode } from "../Configs";

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Fade,
  Typography,
} from "@material-ui/core";
import { useStyles } from "../styles";
import Logo from "../components/Logo";
import { Store } from "../Store";
import { setOrderType } from "../actions";
import { useIntl } from "react-intl";

export default function HomeScreen(props) {
  const { state, dispatch } = useContext(Store);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const styles = useStyles();
  let { userInfo } = state.userData;
  //let { setting } = state.userSetting;
  console.log(userInfo);
  const themeColor = userInfo?.themeColor || '#ffbc01';
  const themeTxtColor = userInfo?.themeTxtColor || '#000';


  const chooseHandler = (orderType) => {
    setOrderType(dispatch, orderType);
    props.history.push("/order?" + window.location.href.split("?")[1]);
  };

  const isRestaurantOpen = () => {
    if (userInfo.closing_start_date && userInfo.closing_end_date) {
      let closeStart = new Date(userInfo.closing_start_date).getTime();
      let closeEnd = new Date(userInfo.closing_end_date).getTime();
      let now = new Date().getTime();
      if (!(now > closeStart && now < closeEnd)) {
        if (new Date().getHours() > userInfo.openTime && new Date().getHours() < userInfo.closeTime) {
          return true;
        }
      }
    }
    else {
      return true;
    }
    return false


  }
  const isScan = getParameterByName("isScan") === "true";

  return (
    <>
      {userInfo && !isRestaurantOpen() && <div className={"custom_center"}>
        <h1>{userInfo.closing_remark || "Restaurant is closed for now!"}</h1>
      </div>}
      <Fade in={true}>
        <Box
          id="contmain"
          className={[styles.root, styles.navy]}
          style={{ backgroundColor: userInfo?.themeColor || '#ffbc01', minHeight: "100vh" }}
        >
          <Box id="box" className={[styles.main, styles.center]}>
            <div id="backlogo">
              {!isScan ? (
                <div id="imgback">
                  <span
                    onClick={() => {
                      props.history.push(
                        `/?` + window.location.href.split("?")[1]
                      );
                    }}
                    style={{ color: "#000" }}
                  >
                    <img
                      src="images/back-btn.png"
                      alt="Back"
                      style={{
                        width: "35px",
                        height: "35px",
                        marginTop: "10px",
                        marginLeft: "10px",
                      }}
                    />
                  </span>
                </div>
              ) : (
                ""
              )}

              <div id="imgdiv">
                <div className="logo">
                  {userInfo && userInfo.logoImg ? (
                    <img
                      src={userInfo.logoImg}
                      alt="logo"
                      style={{ maxHeight: "70px", maxWidth: "180px", objectFit: "contain" }}
                    />
                  ) : (
                    <h1></h1>
                  )}
                </div>
              </div>
            </div>
            <Typography className={[styles.bold, styles.title3]} style={{ color: themeTxtColor }} variant="h3" component="h3" id='title' >
              {t({ id: "welcome_msg", defaultMessage: "Welcome!" })}
            </Typography>
            <Box className={`${styles.cards} ${isScan ? 'is-scan-mode' : ''}`} id="choose_cards">
              {userInfo && isRestaurantOpen() && !userInfo?.onlyTakeAway && (
                <div
                  className="premium-card"
                  onClick={() => chooseHandler("Eat In")}
                >
                  <div className="premium-card-content">
                    <img
                      alt="Eat In"
                      src="/images/eatin.png"
                      className="premium-icon"
                    />
                    <Typography
                      component="p"
                      className="premium-card-text"
                    >
                      {t({ id: "eat_here", defaultMessage: "EAT HERE" })}
                    </Typography>
                    <span className="premium-card-arrow">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </div>
                </div>
              )}

              {userInfo && isRestaurantOpen() && (
                <div
                  className="premium-card"
                  onClick={() => chooseHandler("Take Away")}
                >
                  <div className="premium-card-content">
                    <img
                      alt="Take Away"
                      src="/images/takeout.png"
                      className="premium-icon"
                    />
                    <Typography
                      component="p"
                      className="premium-card-text"
                    >
                      {t({ id: "take_away", defaultMessage: "TAKE AWAY" })}
                    </Typography>
                    <span className="premium-card-arrow">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </div>
                </div>
              )}

              {isScan && (
                <div
                  className="premium-card"
                  onClick={() => chooseHandler("Delivery")}
                >
                  <div className="premium-card-content">
                    <img
                      alt="Delivery"
                      src="/images/delivery.png"
                      className="premium-icon"
                    />
                    <Typography
                      component="p"
                      className="premium-card-text"
                    >
                      {t({ id: "delivery", defaultMessage: "DELIVERY" })}
                    </Typography>
                    <span className="premium-card-arrow">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </span>
                  </div>
                </div>
              )}
            </Box>
          </Box>
        </Box>
      </Fade>
    </>
  );
}

{
  /* <button onClick={() => {
  props.history.push(`/?` + window.location.href.split('?')[1]);
}} className='btn btn-dark ms-4 mb-4' style={{width:"80px",textAlign:"center"}}>
  BACK
</button> */
}
